function cecilInstallment()
{
    
    var current_currency = $('#in-context-paypal-metadata').attr('data-currency');
    var string_variant_price = $('.ymq_cart_total_price').html();
    if (current_currency == "GBP")
    {
        var currency_symbol = "£";
        var variant_price = parseFloat(string_variant_price.replace("£", "").replace("$", "")).toFixed(2);
    }
    else if (current_currency == "EUR")
    {
        var currency_symbol = "€";
        var variant_price = parseFloat(string_variant_price.replace("€", "").replace("$", "").replace(",", ".")).toFixed(2);
    }
    else
    {
        var currency_symbol = "$";
        var variant_price = parseFloat(string_variant_price.replace("$", "").replace("$", "")).toFixed(2); 
    }
    var installment = parseFloat(variant_price)/4;
    if (current_currency == "EUR")
    {
        installment = installment.toFixed(2).toString().replace(".", ",");
    }
    $('#cecil-widget .sezzle-payment-amount.sezzle-button-text').html(currency_symbol+installment);
}
$(document).ready(function(){
    cecilInstallment();
    var sezzle_checkout_button = $('div#shopify-section-sezzle-checkout-button');
    $(sezzle_checkout_button).remove();
    $('input[name="checkout"].btn.cart-submit').after(sezzle_checkout_button);
    $('input[name="checkout"].btn.cart-submit+div#shopify-section-sezzle-checkout-button').addClass('visible');
});